import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
import { Clock, Shield, Check, AlertTriangle, TrendingUp } from 'lucide-react';
export function PricingSection() {
  // Simple countdown logic for visual effect
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 27,
    s: 35
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.s > 0) return {
          ...prev,
          s: prev.s - 1
        };
        if (prev.m > 0) return {
          ...prev,
          m: prev.m - 1,
          s: 59
        };
        if (prev.h > 0) return {
          h: prev.h - 1,
          m: 59,
          s: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="pricing" className="bg-zinc-950 text-white py-24 px-4" data-id="element-128">
      <div className="max-w-5xl mx-auto" data-id="element-129">
        {/* URGENCY BANNER */}
        <div className="bg-red-600 rounded-2xl p-6 text-center mb-16 shadow-2xl shadow-red-900/20 border border-red-500" data-id="element-130">
          <div className="flex items-center justify-center gap-2 text-red-100 font-bold uppercase tracking-widest text-sm mb-4" data-id="element-131">
            <Clock className="w-5 h-5" data-id="element-132" /> Precio de lanzamiento — Cierra en:
          </div>
          <div className="font-display font-black text-5xl md:text-7xl tracking-tight mb-6" data-id="element-133">
            {String(timeLeft.h).padStart(2, '0')} :{' '}
            {String(timeLeft.m).padStart(2, '0')} :{' '}
            {String(timeLeft.s).padStart(2, '0')}
          </div>
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-lg font-medium" data-id="element-134">
            <span className="flex items-center gap-2" data-id="element-135">
              <AlertTriangle className="w-5 h-5" data-id="element-136" /> Después sube $10.000 ARS. No
              vuelve.
            </span>
            <span className="hidden md:inline" data-id="element-137">•</span>
            <span className="text-red-200" data-id="element-138">🔴 68% de los cupos ya tomados</span>
          </div>
        </div>

        <div className="text-center mb-12" data-id="element-139">
          <h2 className="font-display font-black text-4xl md:text-5xl uppercase" data-id="element-140">
            Elegí tu Pack
          </h2>
        </div>

        {/* PRICING CARDS */}
        <div className="grid md:grid-cols-2 gap-8 mb-20" data-id="element-141">
          {/* Basic Pack */}
          <div className="bg-zinc-900 border border-zinc-800 rounded-3xl p-8 flex flex-col" data-id="element-142">
            <div className="mb-8" data-id="element-143">
              <h3 className="font-display font-black mb-2 text-white text-[28px]" data-id="element-144">
                PACK NUTRICIÓN PRO
              </h3>
              <p className="text-gray-400" data-id="element-145">Todo el sistema de consultorio</p>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-146">
              <li className="flex items-center gap-3" data-id="element-147">
                <Check className="text-brand w-5 h-5 shrink-0" data-id="element-148" /> 6 Tomos
                Completos
              </li>
              <li className="flex items-center gap-3" data-id="element-149">
                <Check className="text-brand w-5 h-5 shrink-0" data-id="element-150" /> 6 Bonos
                Estratégicos
              </li>
              <li className="flex items-center gap-3" data-id="element-151">
                <Check className="text-brand w-5 h-5 shrink-0" data-id="element-152" /> Acceso de por
                vida
              </li>
              <li className="flex items-center gap-3" data-id="element-153">
                <Check className="text-brand w-5 h-5 shrink-0" data-id="element-154" />{' '}
                Actualizaciones gratis
              </li>
            </ul>

            <div className="mb-8" data-id="element-155">
              <div className="text-gray-500 line-through text-xl mb-1" data-id="element-156">
                $75.000 ARS
              </div>
              <div className="font-display font-black text-white text-[40px]" data-id="element-157">
                $18.990{' '}
                <span className="text-2xl text-gray-400 font-sans font-bold" data-id="element-158">
                  ARS
                </span>
              </div>
            </div>

            <Button fullWidth variant="outline" onClick={() => window.location.href = 'https://www.bibliotecapro.online/cart/53413328781619:1'} data-id="element-159">
              QUIERO MI PACK PRO
            </Button>
          </div>

          {/* Premium Pack */}
          <div className="bg-gradient-to-b from-brand/20 to-zinc-900 border-2 border-brand rounded-3xl p-8 flex flex-col relative transform md:-translate-y-4 shadow-2xl shadow-brand/20" data-id="element-160">
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-brand text-white font-bold uppercase tracking-wider py-1 px-4 rounded-full text-sm whitespace-nowrap" data-id="element-161">
              ⭐ MÁS VENDIDO
            </div>

            <div className="mb-8" data-id="element-162">
              <h3 className="font-display font-black mb-2 text-white text-[28px]" data-id="element-163">
                PACK + ACELERADOR
              </h3>
              <p className="text-brand-light font-medium" data-id="element-164">
                Sistema de pacientes 24/7
              </p>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-165">
              <li className="flex items-center gap-3" data-id="element-166">
                <Check className="text-brand w-5 h-5 shrink-0" data-id="element-167" />{' '}
                <strong className="text-white" data-id="element-168">Todo lo del Pack Pro</strong>
              </li>
              <li className="flex items-center gap-3" data-id="element-169">
                <Check className="text-brand w-5 h-5 shrink-0" data-id="element-170" /> Sistema Meta
                Ads paso a paso
              </li>
              <li className="flex items-center gap-3" data-id="element-171">
                <Check className="text-brand w-5 h-5 shrink-0" data-id="element-172" /> Guiones de
                anuncios ganadores
              </li>
              <li className="flex items-center gap-3" data-id="element-173">
                <Check className="text-brand w-5 h-5 shrink-0" data-id="element-174" /> Segmentación
                exacta Argentina
              </li>
              <li className="flex items-center gap-3" data-id="element-175">
                <Check className="text-brand w-5 h-5 shrink-0" data-id="element-176" /> Funnel
                completo de captación
              </li>
            </ul>

            <div className="mb-8" data-id="element-177">
              <div className="text-gray-500 line-through text-xl mb-1" data-id="element-178">
                $95.000 ARS
              </div>
              <div className="font-display font-black text-brand-light text-[40px]" data-id="element-179">
                $26.990{' '}
                <span className="text-2xl text-gray-400 font-sans font-bold" data-id="element-180">
                  ARS
                </span>
              </div>
            </div>

            <Button fullWidth onClick={() => window.location.href = 'https://www.bibliotecapro.online/cart/53413329207603:1'} data-id="element-181">
              QUIERO EL PACK + ACELERADOR
            </Button>
          </div>
        </div>

        {/* UPSELL EXPLANATION */}
        <div className="bg-zinc-900 rounded-3xl p-8 md:p-12 border border-zinc-800 mb-20" data-id="element-182">
          <div className="text-center mb-10" data-id="element-183">
            <TrendingUp className="w-12 h-12 text-brand mx-auto mb-4" data-id="element-184" />
            <h3 className="font-display font-black text-3xl uppercase" data-id="element-185">
              ¿Qué agrega el Acelerador?
            </h3>
            <p className="text-xl text-gray-400 mt-2" data-id="element-186">
              El Pack te da el sistema para atender. El Acelerador te da el
              sistema para conseguir pacientes.
            </p>
          </div>

          <div className="overflow-x-auto" data-id="element-187">
            <table className="w-full text-left border-collapse" data-id="element-188">
              <thead data-id="element-189">
                <tr className="border-b-2 border-zinc-800" data-id="element-190">
                  <th className="py-4 px-4 text-gray-400 font-bold uppercase" data-id="element-191">
                    Situación
                  </th>
                  <th className="py-4 px-4 text-red-400 font-bold uppercase" data-id="element-192">
                    ❌ Sin Acelerador
                  </th>
                  <th className="py-4 px-4 text-brand font-bold uppercase" data-id="element-193">
                    ✅ Con Acelerador
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-zinc-800" data-id="element-194">
                <tr data-id="element-195">
                  <td className="py-4 px-4 font-medium" data-id="element-196">
                    Turnos libres esta semana
                  </td>
                  <td className="py-4 px-4 text-gray-400" data-id="element-197">
                    Esperás que vengan
                  </td>
                  <td className="py-4 px-4 text-white font-bold" data-id="element-198">
                    Anuncio = llenos en 48 hs
                  </td>
                </tr>
                <tr data-id="element-199">
                  <td className="py-4 px-4 font-medium" data-id="element-200">Se va un paciente</td>
                  <td className="py-4 px-4 text-gray-400" data-id="element-201">
                    Tardás semanas en reemplazarlo
                  </td>
                  <td className="py-4 px-4 text-white font-bold" data-id="element-202">
                    Encendés el grifo (5 msj/día)
                  </td>
                </tr>
                <tr data-id="element-203">
                  <td className="py-4 px-4 font-medium" data-id="element-204">Ingresos del mes</td>
                  <td className="py-4 px-4 text-gray-400" data-id="element-205">Impredecibles</td>
                  <td className="py-4 px-4 text-white font-bold" data-id="element-206">
                    Calculables con $1.500/día
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* GUARANTEE */}
        <div className="max-w-3xl mx-auto bg-white text-black rounded-3xl p-8 md:p-12 text-center border-4 border-brand" data-id="element-207">
          <Shield className="w-16 h-16 text-brand mx-auto mb-6" data-id="element-208" />
          <h3 className="font-display font-black text-3xl md:text-4xl uppercase mb-6" data-id="element-209">
            Garantía 7 Días — Sin Preguntas
          </h3>
          <p className="text-lg text-gray-700 mb-6 font-medium" data-id="element-210">
            Abrís los tomos. Los usás en el consultorio. Si en 7 días no es lo
            que esperabas: devolución del 100% sin formularios, sin drama.
          </p>
          <p className="text-xl font-bold text-brand" data-id="element-211">
            Tasa de devoluciones: menos del 1%.
            <br data-id="element-212" />
            ¿Por qué tan baja? Porque el sistema funciona.
          </p>
        </div>
      </div>
    </section>;
}